import './GenerateReportModal.scss';
import '@justgiving/modal/src/Modal.scss';

import React, { FunctionComponent } from 'react';

import Modal from '@justgiving/modal';
import config from '../../config';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen?: boolean;
  onRequestClose: () => void;
};

const GenerateReportModal: FunctionComponent<Props> = (props) => {
  const { t } = useTranslation();
  return (
    <Modal
      {...props}
      classNames="generateReportModal"
      style={{
        overlay: { zIndex: 100 },
        content: {
          padding: 0,
          margin: 'auto',
          right: 'unset',
        },
      }}
    >
      <iframe
        className="generateReportModal__iframe "
        src={config.REPORTING_MODAL_URL}
        title={t('reportingModal.title')}
        frameBorder="0"
      ></iframe>
    </Modal>
  );
};

export default GenerateReportModal;
